export default __webpack_public_path__ + "static/contact-64f7186a05775dc813fbd5701eb36242.png";